export default function MapViewSideAlertBox(props) {

    console.log(props)

    const style = {
        backgroundColor: props.color_code,
        width: "150px",
        height: "130px",
    };


    return (
        <div style={style}>
                <table width="100%" height="100%">
                    <tr height="56px">
                        <td align="center" className="map_view_side_alert_box_header">{props.description}</td>
                    </tr>
                    <tr>
                        <td align="center" valign="top" className="map_view_side_alert_box_value">
                            {props.value}
                        </td>
                    </tr>

                </table>
            </div>

    );
}
